import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";
import { monthYearKey } from "utils";
import { useFetch } from "@/hooks/useFetch";
import { fetchMonthlyDraftTimesheet } from "./api";

export default function useMonthlyDraftTimesheet(date) {
  const firstDayOfMonth = startOfMonth(date);
  const lastDayOfMonth = endOfMonth(date);
  const calendarStart = startOfWeek(firstDayOfMonth, { weekStartsOn: 1 });
  const calendarEnd = endOfWeek(lastDayOfMonth, { weekStartsOn: 1 });

  const { data: timesheetData, isLoading } = useFetch({
    queryKey: ["draft_timesheet", "calendar", monthYearKey(firstDayOfMonth)],
    queryFn: () => fetchMonthlyDraftTimesheet(calendarStart, calendarEnd),
  });

  const transformTimesheetData = () => {
    if (!timesheetData) return {};

    return timesheetData.reduce((acc, entry) => {
      const dateStr = entry.date;
      if (!acc[dateStr]) {
        acc[dateStr] = [];
      }

      acc[dateStr].push({
        id: entry.id,
        name: entry.description || "No description",
        time: "",
        datetime: `${dateStr}T00:00`,
        href: "#",
        hours: entry.logged_hours,
      });
      return acc;
    }, {});
  };

  return {
    timesheetData,
    isLoading,
    transformedData: transformTimesheetData(),
  };
}
